import HowToPlayModal from './HowToPlayModal';

export default HowToPlayModal;